import { render, staticRenderFns } from "./ModalConfirmCancelSlugReservation.vue?vue&type=template&id=e0352ffa&scoped=true&"
import script from "./ModalConfirmCancelSlugReservation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmCancelSlugReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0352ffa",
  null
  
)

export default component.exports